import { mapboxgl } from 'core/utils/map/mapbox-gl';
import { createRiskMapCluster, type RiskMapClusterCounts } from './risk-map-cluster.utils';
import type { RiskMapClusterColors } from './risk-map-cluster.constants';

export interface CreateRiskMapClusterMarkerOptions {
  colors?: RiskMapClusterColors;
}

export interface RiskMapClusterMarker {
  marker: mapboxgl.Marker;
  element: HTMLElement;
}

export const createRiskMapClusterMarker = (
  map: mapboxgl.Map,
  lngLat: [number, number],
  counts: RiskMapClusterCounts,
  options: CreateRiskMapClusterMarkerOptions = {}
): RiskMapClusterMarker => {
  const colors = options.colors;
  const baseSvg = createRiskMapCluster(counts, { colors });
  let hoverSvg: SVGSVGElement | undefined;

  const element = document.createElement('div');
  element.style.cursor = 'pointer';
  element.appendChild(baseSvg);

  element.addEventListener('mouseenter', () => {
    const currentHoverSvg = hoverSvg ?? createRiskMapCluster(counts, { hover: true, colors });
    hoverSvg = currentHoverSvg;
    element.replaceChildren(currentHoverSvg);
  });
  element.addEventListener('mouseleave', () => {
    element.replaceChildren(baseSvg);
  });

  const marker = new mapboxgl.Marker({ element }).setLngLat(lngLat).addTo(map);
  return { marker, element };
};
